import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';

class SelectList extends Component {
  constructor() {
    super();
    this.renderDropdownList = this.renderDropdownList.bind(this);
    this.renderSelectOptions = this.renderSelectOptions.bind(this);
  }

  renderSelectOptions(value) {
    const isObject = value !== null && typeof value === 'object';
    const optionVal = isObject ? value[this.props.valueField] : value;
    const optionName = isObject ? value[this.props.nameField] : value;

    return (
      <option key={optionVal} value={optionVal}>
        {optionName}
      </option>
    );
  }

  renderDropdownList({ input, disabled, autoComplete, meta: { error }, data }) {
    const { prompt } = this.props;

    return (
      <div>
        <select
          {...input}
          disabled={disabled}
          className="jg-form-control-select"
          autoComplete={autoComplete}
        >
          {prompt && <option value="">{prompt}</option>}
          {data.map(this.renderSelectOptions)}
        </select>
        {error && <span className="jg-form-error-copy">{error}</span>}
      </div>
    );
  }

  render() {
    const {
      name,
      data,
      label,
      onChange,
      valueField,
      nameField,
      disabled,
      autoComplete,
    } = this.props;

    return (
      <div>
        <Field
          disabled={disabled}
          name={name}
          component={this.renderDropdownList}
          data={data}
          label={label}
          onChange={onChange}
          valueField={valueField}
          textField={nameField}
          autoComplete={autoComplete}
        />
      </div>
    );
  }
}
SelectList.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  prompt: PropTypes.string,
  valueField: PropTypes.string,
  nameField: PropTypes.string,
  autoComplete: PropTypes.string,
  data: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  onChange: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
};

SelectList.defaultProps = {
  label: undefined,
  prompt: undefined,
  valueField: 'value',
  nameField: 'name',
  onChange: () => {},
  disabled: false,
  autoComplete: 'off',
};

export default SelectList;
